(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lu-barra-aviso"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lu-announcement-ticker')) {
    customElements.define('lu-announcement-ticker', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.init());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        clearTimeout(this.resizeTimer);
        this.resizeObserver?.disconnect();
      }

      init() {
        this.viewport = this.querySelector('[data-ticker-viewport]');
        this.track = this.querySelector('[data-ticker-track]');
        this.group = this.querySelector('[data-ticker-group]');

        if (!this.viewport || !this.track || !this.group) return;

        this.fillTrack();

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => {
            clearTimeout(this.resizeTimer);

            this.resizeTimer = setTimeout(() => {
              this.fillTrack();
            }, 100);
          });

          this.resizeObserver.observe(this.viewport);
          this.resizeObserver.observe(this.group);
        }
      }

      fillTrack() {
        const viewportWidth = this.viewport.getBoundingClientRect().width;

        if (!viewportWidth) return;

        const items = Array.from(this.group.children);

        if (!items.length) return;

        const enteredSpacing = Number(this.dataset.messageSpacing);

        const messageSpacing = Number.isFinite(enteredSpacing)
          ? Math.max(12, enteredSpacing)
          : 20;

        // Espaço igual entre todas as mensagens.
        // Metade fica de cada lado do separador.
        const gap = messageSpacing / 2;

        this.style.setProperty('--lu-ticker-message-gap', `${gap}px`);

        const groupWidth = this.group.getBoundingClientRect().width;

        if (!groupWidth) return;

        // A faixa inteira percorre exatamente a largura de um grupo.
        this.style.setProperty('--lu-ticker-distance', `${groupWidth}px`);

        this.track
          .querySelectorAll('[data-ticker-clone]')
          .forEach(clone => clone.remove());

        const copies = Math.max(
          3,
          Math.ceil((viewportWidth * 2) / groupWidth) + 1
        );

        for (let index = 1; index < copies; index += 1) {
          const clone = this.group.cloneNode(true);

          clone.removeAttribute('data-ticker-group');
          clone.setAttribute('data-ticker-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.inert = true;

          clone
            .querySelectorAll('[data-shopify-editor-block]')
            .forEach(item => {
              item.removeAttribute('data-shopify-editor-block');
            });

          this.track.append(clone);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-avancado"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lu-media-slides')) {
    customElements.define('lu-media-slides', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.init());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        clearTimeout(this.timer);
        clearTimeout(this.videoStartTimer);
        this.events?.abort();
        this.observer?.disconnect();
        this.querySelectorAll('video').forEach(video => video.pause());
        this.ready = false;
      }

      init() {
        if (!this.isConnected || this.ready) return;

        this.ready = true;
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.track = this.querySelector('[data-track]');
        this.navigation = this.querySelector('[data-navigation]');
        this.navButtons = [...this.querySelectorAll('[data-slide-button]')];

        this.index = 0;
        this.interval = Math.max(2, Number(this.dataset.interval) || 5) * 1000;
        this.mobile = matchMedia('(max-width: 749px)');
        this.editorSelected = false;
        this.inView = true;
        this.events = new AbortController();

        const options = { signal: this.events.signal };

        const on = (target, type, handler) => {
          target.addEventListener(type, handler, options);
        };

        on(this, 'click', event => {
          const button = event.target.closest('[data-slide-button]');

          if (!button || !this.navigation?.contains(button)) return;

          const index = Number(button.dataset.slideButton);

          if (
            !Number.isInteger(index)
            || index < 0
            || index >= this.slides.length
          ) return;

          event.preventDefault();
          this.show(index);
        });

        on(this, 'keydown', event => {
          if (event.target.closest('video, input, select, textarea')) return;

          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();

            this.show(
              this.index + (event.key === 'ArrowRight' ? 1 : -1)
            );
          }
        });

        on(this, 'pointerdown', event => {
          this.swipe = event.pointerType === 'touch'
            && !event.target.closest('video, button')
            ? { x: event.clientX, y: event.clientY }
            : null;
        });

        on(this, 'pointerup', event => {
          if (!this.swipe) return;

          const dx = event.clientX - this.swipe.x;
          const dy = event.clientY - this.swipe.y;

          this.swipe = null;

          if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy)) {
            this.suppressClick = true;
            this.show(this.index + (dx < 0 ? 1 : -1));

            setTimeout(() => {
              this.suppressClick = false;
            }, 400);
          }
        });

        on(this, 'pointercancel', () => {
          this.swipe = null;
        });

        this.addEventListener('click', event => {
          if (this.suppressClick && event.target.closest('a')) {
            event.preventDefault();
          }
        }, { ...options, capture: true });

        on(document, 'visibilitychange', () => this.refresh());

        on(this.mobile, 'change', () => {
          this.show(this.index, true);
        });

        on(document, 'shopify:block:select', event => {
          const index = this.slides.findIndex(slide => {
            return slide.dataset.blockId === event.detail.blockId;
          });

          if (index < 0) return;

          this.editorSelected = true;
          this.show(index);
        });

        on(document, 'shopify:block:deselect', event => {
          const belongsToThisSection = this.slides.some(slide => {
            return slide.dataset.blockId === event.detail.blockId;
          });

          if (!belongsToThisSection) return;

          this.editorSelected = false;
          this.refresh();
        });

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.inView = entries[0].isIntersecting;
            this.refresh();
          }, { threshold: 0.1 });

          this.observer.observe(this);
        }

        this.show(0, true);
      }

      show(index, immediate = false) {
        if (!this.slides.length) return;

        clearTimeout(this.timer);
        clearTimeout(this.videoStartTimer);

        this.index = (index + this.slides.length) % this.slides.length;

        this.navButtons.forEach((button, position) => {
          button.setAttribute(
            'aria-current',
            String(position === this.index)
          );
        });

        const activeButton = this.navButtons[this.index];

        if (activeButton && this.navigation) {
          const left = activeButton.offsetLeft;
          const right = left + activeButton.offsetWidth;

          if (left < this.navigation.scrollLeft) {
            this.navigation.scrollLeft = Math.max(0, left - 3);
          } else if (
            right > this.navigation.scrollLeft + this.navigation.clientWidth
          ) {
            this.navigation.scrollLeft =
              right - this.navigation.clientWidth + 3;
          }
        }

        this.slides.forEach((slide, position) => {
          const active = position === this.index;

          slide.inert = !active;
          slide.setAttribute('aria-hidden', String(!active));
          slide.setAttribute(
            'aria-label',
            `${position + 1} de ${this.slides.length}`
          );

          const host = slide.querySelector('[data-video-host]');

          if (!host) return;

          const mode = this.mobile.matches ? 'mobile' : 'desktop';

          if (!active || host.dataset.mode !== mode) {
            host.querySelector('video')?.pause();
            host.replaceChildren();
            delete host.dataset.mode;
          }
        });

        this.track.style.transform =
          `translate3d(-${this.index * 100}%, 0, 0)`;

        const activeSlide = this.slides[this.index];

        const activeHasVideo = Boolean(
          activeSlide?.querySelector('[data-video-host]')
        );

        const mountAndRefresh = () => {
          if (!this.isConnected || !this.ready) return;

          this.mountActiveVideo();
          this.refresh();
        };

        if (immediate || !activeHasVideo) {
          mountAndRefresh();
        } else {
          this.videoStartTimer = setTimeout(
            mountAndRefresh,
            this.mobile.matches ? 340 : 470
          );
        }
      }

      mountActiveVideo() {
        const slide = this.slides[this.index];
        const host = slide?.querySelector('[data-video-host]');

        if (!host || host.firstElementChild) return;

        const mode = this.mobile.matches ? 'mobile' : 'desktop';

        const template = slide.querySelector(
          `[data-video-${mode}]`
        );

        if (!template) return;

        host.append(template.content.cloneNode(true));
        host.dataset.mode = mode;
      }

      refresh() {
        if (!this.ready || !this.isConnected) return;

        clearTimeout(this.timer);

        const running = !this.editorSelected
          && !document.hidden
          && this.inView;

        const activeSlide = this.slides[this.index];
        const activeHost = activeSlide?.querySelector('[data-video-host]');
        const video = activeHost?.querySelector('video');

        if (activeHost && !video) return;

        if (video) {
          if (!running) {
            video.pause();
            return;
          }

          video.muted = true;
          video.defaultMuted = true;
          video.volume = 0;
          video.playsInline = true;

          if (
            this.slides.length > 1
            && video.dataset.luEndBound !== 'true'
          ) {
            video.dataset.luEndBound = 'true';

            video.addEventListener('ended', () => {
              const currentSlide = this.slides[this.index];

              const canAdvance = this.ready
                && this.isConnected
                && !this.editorSelected
                && !document.hidden
                && this.inView;

              if (canAdvance && currentSlide?.contains(video)) {
                this.show(this.index + 1);
              }
            });
          }

          const startVideo = () => {
            const canPlayNow = this.isConnected
              && this.ready
              && !this.editorSelected
              && !document.hidden
              && this.inView
              && this.slides[this.index]?.contains(video);

            if (!canPlayNow) return;

            const attempt = video.play();
            attempt?.catch(() => {});
          };

          if (video.readyState >= 3) {
            startVideo();
          } else if (video.dataset.luCanPlayBound !== 'true') {
            video.dataset.luCanPlayBound = 'true';
            video.addEventListener('canplay', startVideo, { once: true });
            video.load();
          }

          return;
        }

        if (running && this.slides.length > 1) {
          this.timer = setTimeout(
            () => this.show(this.index + 1),
            this.interval
          );
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
